<template>
  <div>
    Logged in as {{ displayName.userName }}<br>
    <button @click="auth.signOut()" class="button">Sign Out</button>
  </div>
</template>

<script>
import { auth, db } from '../firebase';

export default {
  data() {
    return { 
          auth,
          displayName: '' 
    }
  },
  computed: {
    serName(){
      return db.doc(`users/${this.user.uid}`);
    }
  },
  firestore() {
    return {
      displayName: this.serName
    };
  },
  props: ['user']
}
</script>
